var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperplane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1611 5.32617L17.6611 22.8262",
    stroke: "currentColor",
    strokeWidth: 1.22619
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6621 22.8262L25.1621 35.3262L35.1621 5.32617L5.16211 15.3262L17.6621 22.8262Z",
    stroke: "currentColor",
    strokeWidth: 1.22619
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/paperplane.15232534aff5bbfafdf0d9edccdc4690.svg";
export { ForwardRef as ReactComponent };